module.exports = __webpack_public_path__ + "img/duo-tab-icon.08598b8c.svg";